import React from 'react';
import { detector } from '../../lib/util/Detect';
import './index.scss';

const storageKey = 'show_signin_tip';

class TopTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowModal: false,
      isShowTip: false,
    };
    this.preventDefault = this.preventDefault.bind(this);
  }

  componentDidMount() {
    const storageValue = window.localStorage.getItem(storageKey);
    const isNotExpiredTime = new Date().getTime() <= new Date('2021/12/31 23:59:59').getTime();
    if ((!storageValue || Number(storageValue) < 5) && isNotExpiredTime) {
      this.setState({ isShowTip: true });
      window.localStorage.setItem(storageKey, Number(storageValue) + 1);
    }
  }

  preventDefault(event) {
    event.preventDefault();
  }

  showTipModal() {
    this.setState({ isShowModal: true });
    // 直接设置已经达到次数限制
    window.localStorage.setItem(storageKey, 5);
  }

  hideTipModal() {
    this.setState({ isShowModal: false, isShowTip: false });
  }

  renderTipModal() {
    const bottom = detector.os.android ? 80 : 8;
    console.log(bottom, 'bottom');
    return (
      <div className={`tip-modal-mask ${this.state.isShowModal ? 'show' : ''}`}>
        <div className="tip-modal" style={{ bottom }}>
          <div className="tip-modal-title">“签到领福利”任务下线公告</div>
          <div className="tip-modal-desc">
            <p style={{ textIndent: '2em' }}>自2021年12月31日起，QQ浏览器福利中心“签到领福利”任务将下线，您已经获得的奖励和其他福利任务不受影响，您可以继续访问福利中心，通过参与其他任务获得奖励。</p>
          </div>
          <div className="tip-modal-btn" onClick={this.hideTipModal.bind(this)}><span>我知道了</span></div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="toptip-comp">
        {this.state.isShowTip && (
          <div className="toptip-wrap" onClick={this.showTipModal.bind(this)}>
            <div className="toptip-desc">福利中心“签到领福利”任务下线公告</div>
          </div>
        )}
        {this.renderTipModal()}
      </div>
    );
  }
}

export default TopTip;
